'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _customSectionSharedFunctions = require('./customSectionSharedFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComponentOfSection = function ComponentOfSection(_ref) {
  var encompassingEncounters = _ref.encompassingEncounters;

  var renderLocation = function renderLocation(location) {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        null,
        'Location: '
      ),
      location.facilityName ? location.facilityName : null,
      location.facilityCode ? _react2.default.createElement(
        'div',
        { className: 'indent-10' },
        "Facility Code: " + location.facilityCode
      ) : null,
      location.facilityIds && location.facilityIds.length > 0 ? _react2.default.createElement(
        'div',
        { className: 'indent-10' },
        "Facility Ids: " + (0, _customSectionSharedFunctions.renderArray)(location.facilityIds)
      ) : null
    );
  };

  var renderEncounter = function renderEncounter(encounter, index) {
    return _react2.default.createElement(
      'li',
      { key: index },
      encounter.timeForDisplay ? _react2.default.createElement(
        'span',
        { className: 'capitalize bold' },
        encounter.timeForDisplay
      ) : _react2.default.createElement(
        'span',
        null,
        'Visit Date: N/A'
      ),
      encounter.location ? renderLocation(encounter.location) : null,
      encounter.responsibleParty ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          'Responsible Party: '
        ),
        (0, _customSectionSharedFunctions.renderEntity)(encounter.responsibleParty)
      ) : null,
      encounter.dischargeDispositionCode ? _react2.default.createElement(
        'div',
        null,
        "Discharge Disposition: " + encounter.dischargeDispositionCode
      ) : null,
      _react2.default.createElement('br', null)
    );
  };

  return _react2.default.createElement(
    'div',
    { className: 'componentOfSection' },
    encompassingEncounters && encompassingEncounters.length > 0 ? _react2.default.createElement(
      'ul',
      null,
      encompassingEncounters.map(renderEncounter)
    ) : null
  );
};

ComponentOfSection.propTypes = {
  encompassingEncounters: _propTypes.array
};

exports.default = ComponentOfSection;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/customSections/ComponentOfSection.js
// module id = 1230
// module chunks = 0